import toast from 'react-hot-toast';

/**
 * Erreurs des documents de l'apprenant (conventions, attestations).
 *
 * Le serveur renvoie un motif précis, par exemple « Impossible de produire la
 * convention pour Muriel SAXEMARD. À compléter : n° RPPS (fiche apprenant). ».
 * Ces fonctions l'affichent tel quel : dans un toast, et dans le bandeau de la
 * fiche session, qui reste visible le temps de corriger.
 */

/** Motif renvoyé par le serveur pour un document, ou le libellé par défaut. */
export const documentError = (response, fallback = 'Une erreur est survenue.') => {
  if (!response) return fallback;
  if (response.errorMessage) return response.errorMessage;
  if (response.message) {
    // 500 : exception côté serveur, pas une information manquante.
    return response.status === 500 ? `Erreur technique : ${response.message}` : response.message;
  }
  return fallback;
};

/** Motifs des échecs d'un traitement en lot (tableau de résultats de customerApi). */
export const batchErrors = (results) => (Array.isArray(results) ? results : [])
  .filter((r) => r && (r.status === 'error' || r.globalStatus === 'error'))
  .map((r) => r.message || 'Échec sans motif renvoyé par le serveur.');

/** Erreur côté navigateur (réseau, réponse illisible…) : à distinguer d'une donnée manquante. */
export const technicalError = (err) => `Erreur technique : ${(err && err.message) || 'inconnue'}.`;

/**
 * Affiche les motifs : un toast (le motif lui-même s'il est seul, sinon un
 * résumé) et la liste complète dans le bandeau de la fiche session.
 */
export const showDocumentErrors = (setAlert, messages, summary) => {
  if (!messages || messages.length === 0) return;
  toast.error(
    messages.length === 1 ? messages[0] : (summary || `${messages.length} document(s) en échec : détail dans le bandeau en haut de la page.`),
    { duration: 8000 }
  );
  if (typeof setAlert === 'function') setAlert(messages);
};
